
import './Navbar.scss';
import React, { useState, useEffect,useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import logo2_black from './images/logo/logo2_black.png';
import logo2_blue from './images/logo/logo2_blue.png';
import logo2_red from './images/logo/logo2_red.png';

import { useSelector, useDispatch } from 'react-redux';
// import { setIsLoggedIn, setTestNm, setUserInfo } from "./reduxToolkit/reduxSlice";
import { setActiveLink, setIsAdmin, setIsLoggedIn, setUserInfo, setUserName } from "./reduxToolkit/reduxIgong";
import fnc from './mymod/commFunction';

function Navbar() {
  const dispatch = useDispatch();
  const testNm = useSelector(state => state.reduxStore.testNm );
  const navigate = useNavigate();
  // const [activeLink, setActiveLink] = useState('home');

  const isLoggedIn = useSelector(state => state.reduxIgong.isLoggedIn);
  const userInfo = useSelector(state => state.reduxIgong.userInfo);
  const isLoginPage = useSelector(state => state.reduxIgong.isLoginPage);
  const activeLink = useSelector(state => state.reduxIgong.activeLink);

  const userName = useSelector(state => state.reduxIgong.userName);
  const userKind = useSelector((state => state.reduxIgong.userKind));

  // const [stName, setStName] = useState('홍길동');
  // const [authority, setAuthority] = useState('');
  // const [userKind, setUserKind] = useState('');

//  console.log(activeLink, 'activeLink');
//  console.log(isLoggedIn, 'isLoggedIn');
    
  const ImageChanger = () => {
    const images = [logo2_black, logo2_blue, logo2_red];
    const [index, setIndex] = useState(0);
    const [fade, setFade] = useState(false);

    useEffect(() => {
      const interval = setInterval(() => {
        setIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 6000);

      return () => clearInterval(interval); // 컴포넌트 언마운트 시 정리
    }, []);

    return <img src={images[index]} alt="Logo" className="imgLogo" />;
  };



  useEffect(()=> {

    // const stName = userInfo.stName || '';
    // const authority = userInfo.authority || 1;
    // const userKind = userInfo.userKind;

    // setStName(stName);
    // setAuthority(authority);
    // setUserKind(userKind);

    // alert(isLoggedIn)

  }, [userInfo]);

  // const handleLinkClick = () => {
  //   if (testNm !== null) {
   
  //     const confirmLeave = window.confirm('시험을 종료하시겠습니까?');
  //     // if (confirmLeave) {
  //     //   // 사용자가 확인을 클릭한 경우, 페이지 이동
  //     //   dispatch(setTestNm(null));
  //     //   navigate(to);
  //     // }
  //   }
  // };

  
  const handleLinkClick = (linkName) => {

    dispatch(setActiveLink(linkName));

  }


  
  const onToggleLogin = () => {
    if (isLoggedIn) {
      const rtn = window.confirm("로그아웃하시겠습니까?");
      if (!rtn) return;

      dispatch(setIsLoggedIn(false));
      dispatch(setUserInfo({}));
      dispatch(setUserName(''));
      dispatch(setIsAdmin(false));
      navigate("/"); 
      handleLinkClick('home')
    } else {
      navigate("/");
    }
  };

  function handleMyRoom() {

    // alert(userKind)

    if (!isLoggedIn) {//나중에 localstorge 삭제할 것
      alert('로그인하세요!');
      return;
    }

    dispatch(setActiveLink('마이룸'));

    switch(userKind) {
      case '학원원장':
        navigate("/myRoomAca")
        break;
      case '학원강사':
        navigate("/myRoomAcaTec")
        break;
      case '학원학생':
        navigate("/myRoomAcaStu")
        break;

      case '학교관리자':
        navigate("/myRoomSch")
        break;

      case '학교교사':
        navigate("/myRoomSchTec")
        break;

      case '학교학생':
        navigate("/myRoomSchStu")
        break;

      case '개인학부모':
        navigate("/myRoomMom")
        break;
      case '개인학생':
        navigate("/myRoomMomStu")
        break;
    }
   
  }

  //=====================================================================
  return (
    <nav className="navbar">
      <div className='navbar-logo' onClick={() => {navigate('/');  handleLinkClick('main'); }}>
                <ImageChanger />
              { true &&  <div className="txt-logo">
                    <p> </p>
                </div> }
          
      </div>

       <div className="navbar-menu">

       { 
          <Link to="/" 
                    className={`link-hover-underline ${ activeLink === "home" ? "active" : "" }`}
                    onClick={() => handleLinkClick('home')} >
                    HOME
          </Link>
        }



        {/* { 
          <Link to="/assessment" 
                    className={`link-hover-underline ${ activeLink === "진단하기" ? "active" : "" }`}
                    onClick={() => handleLinkClick('진단하기')} >
                    진단하기
          </Link>
        } */}

       
        { 
          <Link to="/main" 
                    className={`link-hover-underline ${ activeLink === "아이공" ? "active" : "" }`}
                    onClick={() => handleLinkClick('아이공')} >
                    아이공?
          </Link>
        }


        { 
          <Link to="/live" 
                    className={`link-hover-underline ${ activeLink === "LIVE 특강" ? "active" : "" }`}
                    onClick={() => handleLinkClick('LIVE 특강')} >
                    LIVE 특강
          </Link>
        }


        {/* { 
          <Link to="/shop" 
                    className={`link-hover-underline ${ activeLink === "SHOP" ? "active" : "" }`}
                    onClick={() => handleLinkClick('SHOP')} >
                    SHOP
          </Link>
        } */}

        { 
          <Link to="/Ujab_board" 
                    className={`link-hover-underline ${ activeLink === "알쓸우잡" ? "active" : "" }`}
                    onClick={() => handleLinkClick('알쓸우잡')} >
                    알쓸우잡
          </Link>
        }


        { 
          <Link to="/loginWhere" 
                    className={`link-hover-underline ${ activeLink === "로그인" ? "active" : "" }`}
                    onClick={() => handleLinkClick('로그인')} >
                    로그인
          </Link>
        }

        {/* { 
          <Link to="/loginWhere" 
                    className={`link-hover-underline ${ activeLink === "회원가입" ? "active" : "" }`}
                    onClick={() => handleLinkClick('회원가입')} >
                    회원가입
          </Link>
        } */}

        { 
          <div 
                    className={`link-hover-underline ${ activeLink === "마이룸" ? "active" : "" }`}
                    onClick={handleMyRoom} >
                    마이룸
          </div>
        }


                           
      </div>

      <section className="section-navar-login">
            <article className="navbar-login1"
              onClick={handleMyRoom}
            >     
            {isLoggedIn && (
              <>
                <i className="fas fa-user-circle user-icon"></i>
                <p className="userName">{userName}</p>
              </>
            )}
             
            </article>

            {<article className="navbar-login2" onClick={onToggleLogin}>
                {isLoggedIn ? (
                  <div className='box-user'>
                    <p className='logout'>로그아웃</p>
                  </div>
                ) : "로그인"}

            </article> }

        

      </section>
  

    </nav>
   
  );
}

export default Navbar;
